


































































import Vue from 'vue'
import { mapState } from 'vuex'

import { Stack, GetStack } from '@/api/cems'

export default Vue.extend({
  data() {
    return {
      stack: {
        uid: '',
        id: 0,
        name: '',
        alias: '',
        latitude: '',
        longitude: '',
        fuel: '',
        height: '',
        diameter: '',
        parameterMap: '{}',
        synchronSchedule: '0 15 * * * *',
        syncUTCOffset: '7h',
        sendNotifOnSyncSuccess: false,
        sulfur: '',
        capacity: '',
        collection: 0,
        synchron: false,
        syncRetryCount: 0,
        syncRetryInterval: 0,
        maxResendCount: 0,
        dataLogger: {},
      } as Stack,
    }
  },

  computed: {
    isInstrument(): boolean {
      return this.$store.getters.isInstrument
    },
    ...mapState(['license']),
  },

  methods: {
    stackLoaded(c: Stack) {
      this.stack = c
    },

    async getStack() {
      this.stack = await GetStack(this.stack.uid)
    },

    hasLicense(license?: string[]): boolean {
      if (typeof license == 'undefined') {
        return true
      }

      for (const lic of license) {
        if (this.license.detailLicense[lic]) {
          return true
        }
      }
      return false
    },
  },

  created() {
    this.$route.meta.stackName = ''
    this.stack.uid = this.$route.params.stackUID
    this.getStack()
  },
})
